var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.avatarElement,_vm._b({ref:"avatar",tag:"component",class:_vm.avatarClassName,style:(_vm.cssProps)},'component',_vm.isLink,false),[(_vm.image)?_c('img',{staticClass:"profile-avatar__image",attrs:{"src":_vm.image,"alt":_vm.name}}):_c('NebulaIcon',{staticClass:"profile-avatar__icon",attrs:{"symbolId":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }